import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/UI'

export default function MCSettingsPage() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Configuración</CardTitle>
        <CardDescription>Preferencias por defecto para país, moneda y unidades.</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-2">
        <input className="rounded border px-3 py-2 text-sm" defaultValue="CO" placeholder="País por defecto" />
        <input className="rounded border px-3 py-2 text-sm" defaultValue="COP" placeholder="Moneda por defecto" />
        <select className="rounded border px-3 py-2 text-sm" defaultValue="metric"><option value="metric">Métrico</option><option value="imperial">Imperial</option></select>
      </CardContent>
    </Card>
  )
}
